export const bulkCreateRunTitle = (jobName, texts)=>jobName ? texts.titleNamed({
        name: jobName
    }) : texts.title();
export const hasRunResults = (task)=>{
    if (task.status === 'cancelled') return task.succeeded > 0;
    return task.status === 'ready';
};
